import { NavLink } from "react-router-dom";
import { usePageHeader } from "./PageHeaderContext";

export default function TopbarNew() {
  const { title, subtitle } = usePageHeader();

  return (
    <header className="as-top">
      <div className="as-top-title">
        {title}
        {subtitle && <em>{subtitle}</em>}
      </div>
      <div className="as-top-right">
        <div className="as-top-search">
          <svg
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth={2}
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <circle cx="11" cy="11" r="8" />
            <path d="m21 21-4.3-4.3" />
          </svg>
          <input
            type="text"
            placeholder="Search anything, customers, jobs, chats…"
          />
          <kbd>⌘K</kbd>
        </div>
        <button className="as-top-btn" type="button">
          <svg
            width="13"
            height="13"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth={2}
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M6 8a6 6 0 1 1 12 0c0 7 3 9 3 9H3s3-2 3-9M10 21a2 2 0 0 0 4 0" />
          </svg>
        </button>
        <NavLink to="/app/chat" className="as-top-btn primary">
          <svg
            width="13"
            height="13"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth={2}
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
          </svg>
          Ask Foreman
        </NavLink>
      </div>
    </header>
  );
}
